import { useFieldArray, useFormContext, FieldArrayWithId } from 'react-hook-form';

export interface InviteField {
  id: string;
  first_name: string;
  email: string;
  role?: string;
}

export type InviteMembersFormValues = Readonly<{
  name: string;
  invites: {
    first_name: string;
    email: string;
    role?: string;
  }[];
}>;

export const useInvitesFormField = () => {
  const { control, getValues } = useFormContext<InviteMembersFormValues>();

  const { fields, append, remove } = useFieldArray<InviteMembersFormValues>({
    control,
    name: 'invites',
  });

  const typedFields = fields as FieldArrayWithId<{ invites: InviteField[] }, 'invites', 'id'>[];

  const isInviteGroupEmpty = (
    currentField: 'first_name' | 'email' | 'role',
    currentValue: string,
    index: number,
  ) => {
    const invite = getValues(`invites.${index}`);
    const first_name = currentField === 'first_name' ? currentValue : invite.first_name;
    const email = currentField === 'email' ? currentValue : invite.email;
    const role = currentField === 'role' ? currentValue : invite.role;

    return !first_name?.trim() && !email?.trim() && !role?.trim();
  };

  const addNewInvite = () => {
    append({
      first_name: '',
      email: '',
      role: undefined,
    });
  };

  const removeInvite = (inviteIndex: number) => () => {
    remove(inviteIndex);
  };

  return {
    fields: typedFields,
    addNewInvite,
    removeInvite,
    isInviteGroupEmpty,
  };
};
